// Nordea compound ids look like 2837238/5319800. Shorter digit runs are not trade numbers.
const TRADE_NUMBER_MIN_DIGITS = 5

export const referenceSegments = (code) => {
  if (code == null || String(code).trim() === "") return []
  return String(code).trim().split(/[/-]/).filter(Boolean)
}

export const getTradeIdVariants = (code) => {
  if (code == null || code === "") return []
  const raw = String(code).trim()
  const variants = new Set([raw])
  if (raw.includes("/")) variants.add(raw.replace(/\//g, "-"))
  if (raw.includes("-")) variants.add(raw.replace(/-/g, "/"))
  return [...variants]
}

export const tradeIdContainsReferenceSuffix = (tradeId, referenceCode) => {
  const stored = referenceSegments(tradeId)
  const pdf = referenceSegments(referenceCode)
  if (stored.length < 2 || pdf.length < 2) return false
  if (stored[0] !== pdf[0] || stored[0].length < TRADE_NUMBER_MIN_DIGITS) return false
  const storedTail = stored.slice(1)
  return pdf.slice(1).every((part) => storedTail.includes(part))
}

const suffixRank = (tradeId, referenceCode) => {
  const storedTail = referenceSegments(tradeId).slice(1)
  const pdfTail = referenceSegments(referenceCode).slice(1)
  const startsWithPdf = pdfTail.every((part, index) => storedTail[index] === part)
  return startsWithPdf ? 0 : 1
}

const isOpenOption = (option) => Number(option?.option_state) === 2

const sharesTradeNumber = (tradeId, tradeNumber) => {
  const segments = referenceSegments(tradeId)
  if (segments[0] !== tradeNumber) return false
  const text = String(tradeId)
  return text === tradeNumber || text.startsWith(`${tradeNumber}/`) || text.startsWith(`${tradeNumber}-`)
}

export const findOptionForReference = (options, referenceCode) => {
  const list = (options || []).filter((opt) => opt?.trade_id)
  const variants = new Set(getTradeIdVariants(referenceCode))
  if (variants.size) {
    const exact = list.filter((opt) => variants.has(String(opt.trade_id)))
    const picked = exact.find(isOpenOption) || exact[0]
    if (picked) return picked
  }

  const suffixMatches = list.filter((opt) => tradeIdContainsReferenceSuffix(opt.trade_id, referenceCode))
  const suffixOpen = suffixMatches.filter(isOpenOption)
  const suffixPool = suffixOpen.length ? suffixOpen : suffixMatches
  if (suffixPool.length) {
    const bestRank = Math.min(...suffixPool.map((opt) => suffixRank(opt.trade_id, referenceCode)))
    const best = suffixPool.filter((opt) => suffixRank(opt.trade_id, referenceCode) === bestRank)
    if (best.length === 1) return best[0]
    return null
  }

  const tradeNumber = referenceSegments(referenceCode)[0]
  if (!tradeNumber || tradeNumber.length < TRADE_NUMBER_MIN_DIGITS) return null
  const openWithTradeNumber = list.filter(
    (opt) => isOpenOption(opt) && sharesTradeNumber(opt.trade_id, tradeNumber)
  )
  if (openWithTradeNumber.length === 1) return openWithTradeNumber[0]
  return null
}

export const findOptionForReferences = (options, codes) => {
  for (const code of codes || []) {
    const match = findOptionForReference(options, code)
    if (match) return match
  }
  return null
}
